/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WildcardRouteImport } from './routes/wildcard'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ScoutRouteImport } from './routes/scout'
import { Route as OwnedItemsRouteImport } from './routes/owned-items'
import { Route as OffenseRouteImport } from './routes/offense'
import { Route as ClassesRouteImport } from './routes/classes'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ClassesIndexRouteImport } from './routes/classes.index'
import { Route as ClassesSlugRouteImport } from './routes/classes.$slug'

const WildcardRoute = WildcardRouteImport.update({
  id: '/wildcard',
  path: '/wildcard',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ScoutRoute = ScoutRouteImport.update({
  id: '/scout',
  path: '/scout',
  getParentRoute: () => rootRouteImport,
} as any)
const OwnedItemsRoute = OwnedItemsRouteImport.update({
  id: '/owned-items',
  path: '/owned-items',
  getParentRoute: () => rootRouteImport,
} as any)
const OffenseRoute = OffenseRouteImport.update({
  id: '/offense',
  path: '/offense',
  getParentRoute: () => rootRouteImport,
} as any)
const ClassesRoute = ClassesRouteImport.update({
  id: '/classes',
  path: '/classes',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClassesIndexRoute = ClassesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ClassesRoute,
} as any)
const ClassesSlugRoute = ClassesSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => ClassesRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/classes': typeof ClassesRouteWithChildren
  '/offense': typeof OffenseRoute
  '/owned-items': typeof OwnedItemsRoute
  '/scout': typeof ScoutRoute
  '/settings': typeof SettingsRoute
  '/support': typeof SupportRoute
  '/wildcard': typeof WildcardRoute
  '/classes/$slug': typeof ClassesSlugRoute
  '/classes/': typeof ClassesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/offense': typeof OffenseRoute
  '/owned-items': typeof OwnedItemsRoute
  '/scout': typeof ScoutRoute
  '/settings': typeof SettingsRoute
  '/support': typeof SupportRoute
  '/wildcard': typeof WildcardRoute
  '/classes/$slug': typeof ClassesSlugRoute
  '/classes': typeof ClassesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/classes': typeof ClassesRouteWithChildren
  '/offense': typeof OffenseRoute
  '/owned-items': typeof OwnedItemsRoute
  '/scout': typeof ScoutRoute
  '/settings': typeof SettingsRoute
  '/support': typeof SupportRoute
  '/wildcard': typeof WildcardRoute
  '/classes/$slug': typeof ClassesSlugRoute
  '/classes/': typeof ClassesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/classes'
    | '/offense'
    | '/owned-items'
    | '/scout'
    | '/settings'
    | '/support'
    | '/wildcard'
    | '/classes/$slug'
    | '/classes/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/offense'
    | '/owned-items'
    | '/scout'
    | '/settings'
    | '/support'
    | '/wildcard'
    | '/classes/$slug'
    | '/classes'
  id:
    | '__root__'
    | '/'
    | '/classes'
    | '/offense'
    | '/owned-items'
    | '/scout'
    | '/settings'
    | '/support'
    | '/wildcard'
    | '/classes/$slug'
    | '/classes/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ClassesRoute: typeof ClassesRouteWithChildren
  OffenseRoute: typeof OffenseRoute
  OwnedItemsRoute: typeof OwnedItemsRoute
  ScoutRoute: typeof ScoutRoute
  SettingsRoute: typeof SettingsRoute
  SupportRoute: typeof SupportRoute
  WildcardRoute: typeof WildcardRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/wildcard': {
      id: '/wildcard'
      path: '/wildcard'
      fullPath: '/wildcard'
      preLoaderRoute: typeof WildcardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scout': {
      id: '/scout'
      path: '/scout'
      fullPath: '/scout'
      preLoaderRoute: typeof ScoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/owned-items': {
      id: '/owned-items'
      path: '/owned-items'
      fullPath: '/owned-items'
      preLoaderRoute: typeof OwnedItemsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/offense': {
      id: '/offense'
      path: '/offense'
      fullPath: '/offense'
      preLoaderRoute: typeof OffenseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/classes': {
      id: '/classes'
      path: '/classes'
      fullPath: '/classes'
      preLoaderRoute: typeof ClassesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/classes/': {
      id: '/classes/'
      path: '/'
      fullPath: '/classes/'
      preLoaderRoute: typeof ClassesIndexRouteImport
      parentRoute: typeof ClassesRoute
    }
    '/classes/$slug': {
      id: '/classes/$slug'
      path: '/$slug'
      fullPath: '/classes/$slug'
      preLoaderRoute: typeof ClassesSlugRouteImport
      parentRoute: typeof ClassesRoute
    }
  }
}

interface ClassesRouteChildren {
  ClassesSlugRoute: typeof ClassesSlugRoute
  ClassesIndexRoute: typeof ClassesIndexRoute
}

const ClassesRouteChildren: ClassesRouteChildren = {
  ClassesSlugRoute: ClassesSlugRoute,
  ClassesIndexRoute: ClassesIndexRoute,
}

const ClassesRouteWithChildren =
  ClassesRoute._addFileChildren(ClassesRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ClassesRoute: ClassesRouteWithChildren,
  OffenseRoute: OffenseRoute,
  OwnedItemsRoute: OwnedItemsRoute,
  ScoutRoute: ScoutRoute,
  SettingsRoute: SettingsRoute,
  SupportRoute: SupportRoute,
  WildcardRoute: WildcardRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
